<template>
    <div class="report-page" v-bind:class="{'report-page-vip': showYearVipBtn}">
        <div class="my-report-top-bar">
            <!-- 0、顶部标题栏部分 -->
            <report-title-bar v-if="!fromEmbedded || (fromEmbedded && !isIphone)"></report-title-bar>
            <div class="my-report-top-tab">
                <span v-for="tabItem in tabList" :key="tabItem.tabId" class="my-report-top-tab-item" :class="{'cur': tabItem.tabId == curTab}" @click="clickTopTab(tabItem.tabId)">{{ tabItem.text }}</span>
            </div>
        </div>

        <!-- 1、介绍内容部分 -->
        <div class="report-main-content-box" v-bind:class="{'no-padding-top':(fromEmbedded && isIphone)}">
            <div class="report-main-content">
                <p>八字为什么能测准：经现代科学证实，世界是由能量组成，而我们每个人、每个事物都是能量体。生活在地球上的人类必然受天体干扰、地球磁场支撑等时间及空间综合能量的作用，进而产生了人的运势轨迹。<span class="report-text-yellow">而八字则是千年以来人们对这些能量综合考量，描绘人生起伏状态的工具。</span></p>
                <p>
                    <span style="position: relative;">封建迷信：宿命论，八字定富贵<span class="iconbg icon-report-ji"></span></span><br />
                    <span class="report-text-yellow" style="position: relative;">科普真相：通过数百万的案例反馈我们知道，八字只是描述了先天的人生轨迹，通过后天的选择及努力，我们可以将人生这道计算题找到最优解<span class="iconbg icon-report-yi"></span></span>
                </p>
                <p>本测评根据上千年易学智慧大数据提炼而成，以出生时间、地点对应的地球磁场、时空能量、天体能量为主经人工智能运算得出，帮助大家趋吉避凶。</p>
            </div>
        </div>

        <!-- 2、结果部分 -->
        <report-result :resultType="'report'"></report-result>

        <!-- 提示下载app -->
        <van-popup :value="showDownloadPop" class="report-note-popup" @click-overlay='clickOverlay'>
            <div class="wechat-note-2">
                <p>手机QQ不支持支付功能，</p>
                <p>请下载APP，或转发至微信『文件传输助手』后点击进入完成测算。</p>
            </div>
            <button v-if="btnText != ''" class="report-note-popup-button" @click="clickDownload">{{btnText}}</button>
        </van-popup>

        <!-- 3、底部背景 -->
        <div class="report-bottom">
            <!-- 底部按钮 -->
            <!-- <div v-if="!fromEmbedded" class="report-bottom-button">
                <button class="report-rbul-button report-rbul-button-3" @click="clickNature">
                    <span class="report-rbul-button-span">查看个人天赋矩阵</span>
                </button>
            </div> -->
            <!-- 底部二维码 -->
            <div class="report-bottom-code">
                <img class="report-bottom-code-img" v-bind:src="qrCode" alt="">
            </div>
            <div class="report-bottom-note">
                <!-- <p>注：智能测算属于知识付费，一旦付费不予退款。</p> -->
            </div>
        </div>
        <!-- 4.1、vip解锁按钮 -->
        <vip-year-button v-if="showYearVipBtn && reportData['pay_10001'] == 0 && reportData['pay_10002'] == 0 && reportData['pay_10003'] == 0 && reportData['pay_10004'] == 0 && reportData['pay_10005'] == 0 && reportData['pay_31100'] == 0" :frompage="'report'"></vip-year-button>
        <!-- 4.2、vip解锁按钮 -->
        <div class="deep-seek-button-fixed" @click="clickDeepSeek">
            <div v-if="showTips" class="deep-seek-tips tips-2"></div>
        </div>
        <!-- 5、弹框 -->
        <report-act-remind-popup></report-act-remind-popup>
        <!-- 6、重新生成弹框 -->
        <report-re-pay-popup></report-re-pay-popup>
        <router-view></router-view>
    </div>
</template>

<script>
import ReportTitleBar from '../../layouts/report/ReportTitleBar.vue'
import ReportResult from '../../layouts/report/ReportResult.vue'
import VipYearButton from '../../components/common/VipYearButton.vue'
import ReportActRemindPopup from '../../layouts/report/ReportActRemindPopup.vue';
import ReportRePayPopup from '../../layouts/report/ReportRePayPopup.vue';
import { MIX, UA } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
import { REPORT_DOM } from '../../modules/dom';
export default {
    name: 'ReportPage',
    components: { ReportTitleBar, ReportResult, VipYearButton, ReportActRemindPopup, ReportRePayPopup },
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        showDownloadPop() {
            return this.$store.state.pay.showDownloadPop;
        },
        showYearVipBtn() {
            return this.$store.state.user.showYearVipBtn;
        },
        reportData() {
            return this.$store.state.report.reportData;
        },
    },
    data() {
        return {
            showTips: window.localStorage.getItem('h5_fate_ds_report_tips') ? false : true,
            isIphone: false,
            btnText: '去App Store下载',
            qrCode: require('../../assets/images/report/report-code.png'),
            curTab: 1,
            tabList: [
                {tabId: 1, text: '性格天赋'},
                {tabId: 2, text: '财富提升'},
                {tabId: 3, text: '未来12月运'},
                {tabId: 4, text: '未来5年运'},
                {tabId: 5, text: '总运程'},
                {tabId: 6, text: '更多科普'},
            ]
        }
    },
    mounted() {
        this.$bus.on('updateReportTab', this.updateReportTab);
        var curPath = this.$router.history.current.path;
        var time = curPath.indexOf('embedded') == -1 ? 20 : 500;
        setTimeout(() => {
            window.scrollTo(0, 0);
            this.isIphone = UA.isIphone();
            this.btnText = UA.isIphone() ? '去App Store下载' : '去应用宝下载';
            this.initData();
            this.initDom();
            REPORT_DOM.initReportPageHeightList();
            setTimeout(() => {
                REPORT_DOM.bindReportScrollEvent();
            }, 20);
        }, time);
    },
    destroyed() {
        this.$bus.off('updateReportTab', this.updateReportTab);
    },
    methods: {
        initData() {
            var curPath = this.$router.history.current.path,
                curParams = this.$router.history.current.params,
                detailInfo = this.$store.state.detail.personInfo;
            console.log('initData-----', curParams, detailInfo)
            this.$store.state.report.showReportPage = true;
            if(curPath.indexOf('embedded') == -1 && !detailInfo.id) {
                this.$router.replace('/record');
                return;
            }
        },
        initDom() {
            var curParams = this.$router.history.current.params;
            var fromPage = this.$store.state.report.fromPage;
            console.log('Report---initDom------', curParams, fromPage)
            switch(fromPage) {
                case 'collate':
                    MIX.trackPageViewed('BZPredictionReport', 'home_ai');
                    break;
                case 'detail':
                    MIX.trackPageViewed('BZPredictionReport', 'mingpan_bottom_ai');
                    break;
                case 'nature':
                    MIX.trackPageViewed('BZPredictionReport', 'talent_bottom_ai');
                    break;
                default:
                    break;
            }
        },
        clickTopTab(tabId) {
            this.curTab = tabId;
            REPORT_DOM.updateReportScrollTopByTab(tabId);
        },
        updateReportTab(tabId) {
            if(tabId == this.curTab) {
                return;
            }
            this.curTab = tabId;
        },
        clickNature() {
            var curPath = this.$router.history.current.path;
                curPath = curPath.replace('report', 'nature');
            console.log('clickNature-----', curPath)
            this.$bus.emit('clearDetailNatureTime');
            this.$router.replace(curPath);
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 20);
        },
        clickDownload() {
            window.location = CONFIG.download_url;
        },
        clickOverlay() {
            this.$store.state.pay.showDownloadPop = false;
        },
        clickDeepSeek() {
            var detailInfo = this.$store.state.detail.personInfo;
            console.log('clickDS', detailInfo);
            if(!detailInfo.id) {
                this.$router.replace('/record');
                return;
            }
            if(this.showTips) {
                window.localStorage.setItem('h5_fate_ds_report_tips', 1);
                this.showTips = false;
            }
            this.$showDeepSeek({
                id: detailInfo.id, type: 1
            });
        },
    }
}
</script>